export const delayTime = 15000;

export const socialsBannerLinks = {
  tgLink: 'https://bit.ly/3LoSMkn',
  instagramLink: 'https://bit.ly/3Lmjs5e',
};
